import axiosIns from '@/api/axios'


export const GET_EMPLOYEE_BY_MANAGER = (args) => {
    return axiosIns.get(`/master-data/employee-by-manager/${args}`);
}
export const GENERATE_IDP_EXAMINATION = (args) => {
    return axiosIns.get(`/idp-examination`,args);
}
export const GENERATE_IDP_REPORT = (args) => {
    return axiosIns.get(`/idp-report`,args);
}
export const GET_IDP_EXAMINATION_BY_NIK = (args) => {
    return axiosIns.get(`/idp-examination/${args}`);
}
export const EDIT_PROFICIENCY_IDP = (args) => {
    return axiosIns.put(`/idp-examination/${args.id}`, args.data)
}
export const EDIT_DATA_IDP_EXAMINATION = (args) => {
    return axiosIns.put(`/idp-examination/${args.id}/data`, args.data)
}



